(function() {
    'use strict';
    angular
        .module('doctorclubboApp')
        .factory('Delivery_option_agenzia', Delivery_option_agenzia);

    Delivery_option_agenzia.$inject = ['$resource'];

    function Delivery_option_agenzia ($resource) {
        var resourceUrl =  'api/delivery-option-agenzias/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
